module.exports = __webpack_public_path__ + "img/960.66fb55dc.svg";